<template>
  <div>
    <div class="page-header">
      <div class="pageTitle">
        <div class="pageName">
          {{ "Rule Config for VLAN Profile " + profileId }}
        </div>
      </div>
    </div>
    <div class="row">
      <p style="margin: 20px 15px 10px">
        {{ "This page shows the current vlan profile rule config." }}
      </p>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <block-cntr :btitle="'VLAN Profile Config'" style="height: 410px">
          <div class="form-inline">
            <span style="float: left">
              <div class="btn-group open">
                <div
                  @click="isShowAddTable = true"
                  class="btn"
                  :class="{ disabled: false }"
                  style="padding: 0px"
                >
                  <i class="fa fa-plus page-tableaction"></i>
                </div>
                <div
                  @click="clkDel()"
                  class="btn"
                  :class="{ disabled: false }"
                  style="padding: 0px"
                >
                  <i class="fa fa-trash-o page-tableaction"></i>
                </div>
              </div>
            </span>
          </div>

          <table class="table table-hover table-noneborder-top">
            <thead>
              <tr>
                <th width="40px">
                  <input
                    type="checkbox"
                    v-model="isSelectAll"
                    @change="changeSelectAll()"
                    id="idSelectAll"
                  />
                  <label for="idSelectAll"></label>
                </th>
                <th v-for="(value, key) in title" :key="key" :title="value">
                  {{ value }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(row, index) in vlanTable"
                :key="row.profileId"
                :class="{ 'true:': true }"
                @click="changeSelect(row)"
              >
                <td width="40px">
                  <div @click.stop="" v-if="!row.isNew">
                    <input
                      type="checkbox"
                      v-model="row.selected"
                      :id="'idRowSelect' + index"
                    />
                    <label :for="'idRowSelect' + index"></label>
                  </div>
                </td>
                <td>
                  <div>{{ row.vlanRuleId }}</div>
                </td>
                <td>
                  <div>{{ row.vlanAction | capitalize }}</div>
                </td>
                <td>
                  <div>{{ row.oldVlan | vlanFormat }}</div>
                </td>
                <td>
                  <div>{{ row.oldVlanPri | priFormat }}</div>
                </td>
                <td>
                  <div>{{ row.newVlan | vlanFormat }}</div>
                </td>
                <td>
                  <div>{{ row.newVlanPri | priFormat }}</div>
                </td>
                <td>
                  <div>{{ row.outerVlan }}</div>
                </td>
              </tr>
            </tbody>
          </table>

          <div v-if="isShowAddTable">
            <dialog-box
              :btitle="'Vlan Profile Edit'"
              @close="isShowAddTable = false"
              style="min-height: 410px"
            >
              <form class="form-horizontal" role="form">
                <div class="form-group">
                  <label class="col-sm-3 control-label" for="vlanruleid">{{
                    title.vlanRuleId
                  }}</label>
                  <div class="col-sm-5" :class="{ 'has-error': input_para_check(1)}">
                    <input
                      type="text"
                      name="vlanRuleId"
                      class="form-control"
                      id="vlanruleid"
                      v-model="vlanForm.vlanRuleId"
                      autocomplete="off"
                      placeholder="INTEGER<1-32>"
                    />
                    <small
                        class="help-block"
                        :style="{
                          display: input_para_check(1) ? 'block' : 'none',
                        }"
                        >{{ input_para_check(1) }}
                      </small>
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-sm-3 control-label" for="vlanaction">{{
                    title.vlanAction
                  }}</label>
                  <div class="col-sm-5">
                    <select
                      name="vlanAction"
                      class="form-control"
                      id="vlanaction"
                      v-model="vlanForm.vlanAction"
                    >
                      <option value="" disabled selected style="display: none">
                        please choose..
                      </option>
                      <option value="1">Translate</option>
                      <option value="2">Add</option>
                      <option value="3">Tag</option>
                      <option value="4">Translate&Add</option>
                    </select>
                  </div>
                </div>
                <div v-if="vlanForm.vlanAction != '3'" class="form-group">
                  <label class="col-sm-3 control-label" for="oltvlan">{{
                    title.oldVlan
                  }}</label>
                  <div class="col-sm-5" :class="{ 'has-error': input_para_check(2)}">
                    <input
                      type="text"
                      name="oldVlan"
                      class="form-control"
                      id="oltvlan"
                      v-model="vlanForm.oldVlan"
                      placeholder="INTEGER<1-4094>"
                    />
                    <small
                        class="help-block"
                        :style="{
                          display: input_para_check(2) ? 'block' : 'none',
                        }"
                        >{{ input_para_check(2) }}
                      </small>
                  </div>
                </div>

                <div
                  v-if="vlanForm.vlanAction > '0' && vlanForm.vlanAction < '3'"
                  class="form-group"
                >
                  <label class="col-sm-3 control-label" for="oldpri">{{
                    title.oldVlanPri
                  }}</label>
                  <div class="col-sm-5">
                    <select
                      class="form-control"
                      id="oldpri"
                      v-model="vlanForm.oldVlanPri"
                    >
                      <option value="">
                        None
                      </option>
                      <option value="0">0</option>
                      <option v-for=" pri in 7" :key="pri" :value="pri">{{pri}}</option>
                    </select>
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-sm-3 control-label" for="newvlan">{{
                    title.newVlan
                  }}</label>
                  <div class="col-sm-5" :class="{ 'has-error': input_para_check(3)}">
                    <input
                      type="text"
                      name="newVlan"
                      class="form-control"
                      id="newvlan"
                      v-model="vlanForm.newVlan"
                      placeholder="INTEGER<1-4094>"
                    />
                    <small
                        class="help-block"
                        :style="{
                          display: input_para_check(3) ? 'block' : 'none',
                        }"
                        >{{ input_para_check(3) }}
                      </small>
                  </div>
                </div>

                <div
                  v-if="vlanForm.vlanAction > '0' && vlanForm.vlanAction < '4'"
                  class="form-group"
                >
                  <label class="col-sm-3 control-label" for="newpri">{{
                    title.newVlanPri
                  }}</label>
                  <div class="col-sm-5">
                     <select
                      class="form-control"
                      id="newpri"
                      v-model="vlanForm.newVlanPri"
                    >
                      <option value="">
                        None
                      </option>
                      <option value="0">0</option>
                      <option v-for=" pri in 7" :key="pri" :value="pri">{{pri}}</option>
                    </select>
                  </div>
                </div>

                <div v-if="vlanForm.vlanAction == '4'" class="form-group">
                  <label class="col-sm-3 control-label" for="outerVlan">{{
                    title.outerVlan
                  }}</label>
                  <div class="col-sm-5" :class="{ 'has-error': input_para_check(4)}">
                    <input
                      type="text"
                      name="outerVlan"
                      class="form-control"
                      id="outerVlan"
                      v-model="vlanForm.outerVlan"
                      placeholder="INTEGER<1-4094>"
                    />
                    <small
                        class="help-block"
                        :style="{
                          display: input_para_check(4) ? 'block' : 'none',
                        }"
                        >{{ input_para_check(4) }}
                      </small>
                  </div>
                </div>

                <button
                  type="button"
                  class="btn btn-primary"
                  style="
                    margin-left: 20%;
                    min-width: 77px;
                    color: #fff;
                    background-color: #008b8b;
                    border-color: #008080;
                  "
                  @click="clkApply()"
                >
                  {{ "Apply" }}
                </button>

                <span style="margin-left: 10px">
                  <button
                    type="button"
                    class="btn btn-default"
                    style="min-width: 77px"
                    @click="clkCancel()"
                  >
                    {{ "Cancel" }}
                  </button>
                </span>
              </form>
            </dialog-box>
          </div>
        </block-cntr>
      </div>
    </div>

    <info-box :ibox="iBox"></info-box>
    <waiting-box visible="showWaitingBoxDiag" msg="'mWaitingMsg'"></waiting-box>
  </div>
</template>

<script>
import en from "./../lang/en-US.js"
import BlockCntr from "./../components/BlockCntr.vue"
import { get, post } from "@/utils/http.js"
import DialogBox from "@/components/DialogBox"
import InfoBox from "./../components/InfoBox.vue"

export default {
  name: "profileVlan",
  components: {
    BlockCntr,
    DialogBox,
    InfoBox,
  },

  props: ["profileId"],

  data() {
    return {
      title: {},
      isShowAddTable: false,
      isEditClik: false,
      isSelectAll: false,
      iBox: {},
      select: [],
      vlanForm: {
        vlanRuleId: "",
        vlanAction: "",
        oldVlan: "",
        oldVlanPri: "",
        newVlan: "",
        newVlanPri: "",
        outerVlan: "",
      },

      vlanTable: [],
    }
  },

  created() {
    this.loadvlanProfile()
  },

  watch:{
    'vlanForm.vlanAction':function(){
        this.vlanForm.oldVlan = ""
        this.vlanForm.oldVlanPri = ""
        this.vlanForm.newVlan = ""
        this.vlanForm.newVlanPri = ""
        this.vlanForm.outerVlan = ""
    }
  },

  methods: {
    loadvlanProfile() {
      get("profilevlan?profileId=" + this.profileId)
        .then((res) => {
          this.vlanTable = res.data.data
          this.title = res.data.title
        })
        .catch((err) => {
          console.log(err)
        })
    },

    clkCancel() {
      this.resetField()
      this.isShowAddTable = false
      this.isEditClik = false
    },

    resetField() {
      var vlanformTmp = {
        vlanRuleId: "",
        vlanAction: "",
        oldVlan: "",
        oldVlanPri: "",
        newVlan: "",
        newVlanPri: "",
        outerVlan: "",
      }

      this.vlanForm = vlanformTmp
    },

    profileSortFun(a, b) {
      return Number(a.vlanRuleId) - Number(b.vlanRuleId)
    },

    clkApply() {
      var newProfile = {
        profileId: Number(this.profileId),
        vlanRuleId: Number(this.vlanForm.vlanRuleId),
        vlanAction: Number(this.vlanForm.vlanAction),
        oldVlan: Number(this.vlanForm.oldVlan),
        oldVlanPri: Number(this.vlanForm.oldVlanPri),
        newVlan: Number(this.vlanForm.newVlan),
        newVlanPri: Number(this.vlanForm.newVlanPri),
        outerVlan: Number(this.vlanForm.outerVlan),
        operate: 1,
      }

      var msg = this.input_para_check(0)
      if( msg != null)
      {
          this.showAlertBox(
              "warn",
              "Message",
              msg
          )
          return
      }

      if (this.vlanForm.oldVlanPri == "") {
        newProfile.oldVlanPri = 8
      }
      if (this.vlanForm.newVlanPri == "") {
        newProfile.newVlanPri = 8
      }

      if (!this.isEditClik) {
        for (let i = 0; i < this.vlanTable.length; i++) {
          if (this.vlanTable[i].vlanRuleId == newProfile.vlanRuleId) {
            this.showAlertBox(
              "warn",
              "Message",
              "this vlan rule id has been existed,please choose a new one"
            )
            return
          }
        }
      }
      post("profilevlan", newProfile)
        .then((res) => {
          console.log(res)
          if (
            res.data == undefined ||
            res.data.code === undefined ||
            res.data.code === 0
          ) {
            this.showAlertBox("info", "Info", "Config successful!")
            this.loadvlanProfile()
            /*if (this.isEditClik) {
              let editindex = this.select[0]
              this.vlanTable[editindex]= newProfile
            }
            else
            {
               this.vlanTable.push(newProfile)
               this.vlanTable.sort(this.profileSortFun)
            }*/
          } else this.showAlertBox("warn", "Message", res.data.msg)
        })
        .catch((err) => {
          this.showAlertBox("critical", "error", err)
        })

      this.resetField()
      this.isShowAddTable = false
      this.isEditClik = false
    },

    clkEdit() {
      for (let i = 0; i < this.vlanTable.length; i++) {
        if (this.vlanTable[i].selected) {
          this.vlanForm.vlanRuleId = this.vlanTable[i].vlanRuleId
          this.isShowAddTable = true
          this.isEditClik = true
          this.select[0] = i
          return
        }
      }
    },

    clkDel() {
      var errflag = 0
      var del = []
      var i
      var id = []
      var newProfile = {
        profileId: 0,
        vlanRuleId: 1,
        operate: 2,
      }

      for (i = 0; i < this.vlanTable.length; i++) {
        if (this.vlanTable[i].selected) {
          newProfile.profileId = Number(this.profileId)
          newProfile.vlanRuleId = Number(this.vlanTable[i].vlanRuleId)
          del.push(post("profilevlan", newProfile))
          id.push(this.vlanTable[i].vlanRuleId)
        }
      }

      if (del.length == 0) {
        return
      }

      Promise.all(del)
        .then((res) => {
          console.log(res)
          res.forEach((element, index) => {
            if (
              element.data == undefined ||
              element.data.code === undefined ||
              element.data.code === 0
            ) {
              for (i = 0; i < this.vlanTable.length; i++) {
                if (this.vlanTable[i].vlanRuleId == id[index]) {
                  this.vlanTable.splice(i, 1)
                  break
                }
              }
            } else {
              this.showAlertBox("warn", "Message", element.data.msg)
              errflag = 1
            }
          })
          if (errflag === 0)
            this.showAlertBox("info", "Info", "Delete successful!")
        })

        .catch((err) => {
          this.showAlertBox("critical", "error", err)
        })
    },

    changeSelectAll() {
      for (let i = 0; i < this.vlanTable.length; i++) {
         if (this.isSelectAll) {
          this.$set(this.vlanTable[i], "selected", true)
        } else {
          this.$set(this.vlanTable[i], "selected", false)
        }
      }
    },

    /* 告警弹框 */
    showAlertBox(type, title, txt) {
      this.iBox = {
        visible: true,
        type: type, // info warn critical
        title: title,
        txt: txt,
        btxt: "Close",
      }
    },

    changeSelect(row) {
      console.log(row)
      if (row.selected == undefined) {
        this.$set(row, "selected", true)
      } else row.selected = !row.selected
    },

    input_para_check(value)
    {
      if(value == 1 || value == 0)
      {
        if(this.vlanForm.vlanRuleId != "")
        {
            let vlanRuleId = Number(this.vlanForm.vlanRuleId)
            if(!isNaN(vlanRuleId))
            {
                if(vlanRuleId < 1 || vlanRuleId > 32)
                return "rule id must be in range 1-32"
            }
            else
              return "rule id must be in range 1-32"
        }
      }

      if(value == 2 || value == 0)
      {
        if(this.vlanForm.oldVlan != "")
        {
            let oldVlan = Number(this.vlanForm.oldVlan)
            if(!isNaN(oldVlan))
            {
                if(oldVlan < 0 || oldVlan > 4094)
                return "vlan id must be in range 0-4094"
            }
            else
              return "vlan id must be in range 0-4094"
        }
      }

      if(value == 3 || value == 0)
      {
        if(this.vlanForm.newVlan != "")
        {
            let newVlan = Number(this.vlanForm.newVlan)
            if(!isNaN(newVlan))
            {
                if(newVlan < 1 || newVlan > 4094)
                return "vlan id must be in range 1-4094"
            }
            else
              return "vlan id must be in range 1-4094"
        }
      }

      if(value == 4 || value == 0)
      {
        if(this.vlanForm.outerVlan != "")
        {
            let outerVlan = Number(this.vlanForm.outerVlan)
            if(!isNaN(outerVlan))
            {
                if(outerVlan < 1 || outerVlan > 4094)
                return "vlan id must be in range 1-4094"
            }
            else
              return "vlan id must be in range 1-4094"
        }
      }
      return null
    }
  },

  filters: {
    capitalize: function (value) {
      if (value == "1") return "Translate"
      else if (value == "2") return "Add"
      else if (value == "3") return "Tag"
      else if (value == "4") return "Translate&Add"
      else return value
    },

    priFormat: function (value) {
      if (value == "8") return ""
      else return value
    },

    vlanFormat: function (value) {
      if (value == "0") return ""
      else return value
    },
  },
}
</script>

<style>
.table_edit {
  position: absolute;
  top: 20%;
  left: 20%;
  z-index: 1;
  width: 50%;
}
</style>